var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { INITIAL_FEE, PRICE_PER_TOKEN, SQUARE_MINIMUM_CHARGE, } from "./constants";
export function pMap(inputs, mapper, _a) {
    var _b = _a === void 0 ? { concurrency: 5 } : _a, concurrency = _b.concurrency;
    return __awaiter(this, void 0, void 0, function () {
        var results, index, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    results = [];
                    index = 0;
                    _c.label = 1;
                case 1:
                    if (!(index < inputs.length)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all(inputs.slice(index, index + concurrency).map(mapper))];
                case 2:
                    res = _c.sent();
                    results.push.apply(results, res);
                    index += concurrency;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, results];
            }
        });
    });
}
export function generateTokenSetKey(tokenLayers) {
    return __spreadArray([], tokenLayers, true).filter(function (_a) {
        var visible = _a.visible;
        return visible;
    })
        .reduce(function (a, b) {
        a += b.assetId;
        return a;
    }, "");
}
export function sortLayers(a, b) {
    return a.layerOrder > b.layerOrder ? 1 : -1;
}
export function generateSignatureMessage(_a) {
    var address = _a.address, nonce = _a.nonce;
    return "lasagna.xyz wants you to sign in with your Ethereum account:\n".concat(address, "\n  \nSign in to lasagna with Ethereum.\n  \nURI: https://app.lasagna.xyz\nVersion: 1\nChain ID: 1\nNonce: ").concat(nonce.value, "\nIssued At: ").concat(nonce.issuedAt);
}
export function calculateTokenName(tokenName, tokenId) {
    return tokenName
        ? "".concat(tokenName.replace("{id}", "".concat(tokenId)))
        : "Token #".concat(tokenId);
}
export function calculateTokenDescription(_a) {
    var tokenDescription = _a.tokenDescription, collectionDescription = _a.collectionDescription;
    return tokenDescription === undefined
        ? collectionDescription
        : tokenDescription;
}
function removeTimestamp(collectionId) {
    var TIMESTAMP_DELIMITER = "-";
    var vals = collectionId.split(TIMESTAMP_DELIMITER);
    vals.pop();
    return vals.join(TIMESTAMP_DELIMITER);
}
export function generateMetadataZipFileName(collectionId) {
    return "".concat(removeTimestamp(collectionId), "_metadata.zip");
}
export function generateRarityZipFileName(collectionId) {
    return "".concat(removeTimestamp(collectionId), "_trait_usage.zip");
}
export function generateTokenZipFileName(_a) {
    var collectionId = _a.collectionId, pageNumber = _a.pageNumber;
    return "".concat(removeTimestamp(collectionId), "_").concat("images_page_".concat(pageNumber + 1), ".zip");
}
var DELIMITER = "|";
export function calculateAssetKey(_a) {
    var layerId = _a.layerId, assetId = _a.assetId;
    return layerId + DELIMITER + assetId;
}
export function parseAssetKey(assetKey) {
    var _a = assetKey.split(DELIMITER), layerId = _a[0], assetId = _a[1];
    return { layerId: layerId, assetId: assetId };
}
export function getLayerIdFromAssetKey(assetKey) {
    return assetKey.slice(0, assetKey.indexOf(DELIMITER));
}
export function getTotalPages(itemCount, itemsPerPage) {
    return Math.ceil(itemCount / itemsPerPage);
}
export function getTokenRangeFromPage(_a) {
    var pageNumber = _a.pageNumber, tokensPerPage = _a.tokensPerPage, tokenCount = _a.tokenCount, tokenIdStartsAt = _a.tokenIdStartsAt;
    var startId = pageNumber * tokensPerPage + tokenIdStartsAt;
    var endId = Math.min(startId + tokensPerPage - 1, tokenCount + (tokenIdStartsAt - 1));
    return { startId: startId, endId: endId };
}
export function calculateAmountOwed(tokenCount, amountPaid) {
    var amountOwed = INITIAL_FEE + tokenCount * PRICE_PER_TOKEN - amountPaid;
    // If the charge ends up being less than the Square minimum (or if it's negative), just let 'em have it for free.
    if (amountOwed < SQUARE_MINIMUM_CHARGE) {
        return 0;
    }
    return amountOwed;
}
export function convertCentsToCurrency(cents) {
    return "$".concat((cents / 100).toFixed(2));
}
export function wait(time) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(true);
        }, time);
    });
}
export function calculateCustomMetadata(tokenId, fields) {
    var _a;
    var metadata = {};
    for (var prop in fields) {
        if (prop === "properties.files") {
            var value = [
                {
                    uri: "".concat(fields[prop] || "").concat(tokenId, ".png"),
                    type: "image/png",
                },
            ];
            if (metadata.properties) {
                metadata.properties.files = value;
            }
            else {
                metadata.properties = { files: value };
            }
        }
        else {
            var keys = prop.split(".");
            if (keys.length === 1) {
                metadata[prop] = fields[prop];
            }
            else if (keys.length === 2) {
                var parent = keys[0], child = keys[1];
                if (metadata[parent]) {
                    metadata[parent][child] = fields[prop];
                }
                else {
                    metadata[parent] = (_a = {}, _a[child] = fields[prop], _a);
                }
            }
        }
    }
    return metadata;
}
